import {getUserInfo} from '../utils/session'

const getters = {

  userInfo: state => getUserInfo(),
  token: state => state.user.token,
  count: state => state.other.noticeCount,

  // address
  addressList: state => state.address.addressList,
  selectedAddress: state => state.address.selectedAddress,


  openId: state => state.openid.openId,
  // search
  searchKey: state => {
    if (state.search.searchKey.length <= 0) {
      return JSON.parse(localStorage.getItem('searchKey')) || []
    } else {
      return state.search.searchKey
    }
  }
}

export default getters
